// action - state management
import { SIDEBAR_ACTIONS } from 'config';

// initial state
export const initialState = {
  changeSidebar: false,
  userType: null
};

const zignaAi = (state = initialState, action) => {
  switch (action.type) {
    case SIDEBAR_ACTIONS.CHANGE_SIDEBAR: {
      const { changeSidebar } = action.payload;
      return {
        ...state,
        changeSidebar
      };
    }
    case SIDEBAR_ACTIONS.SET_USER_TYPE:{
      const { userType } = action.payload;
      return {
        ...state,
        userType
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default zignaAi;
